import { Rating as RatingType } from '@sly/core/types';
import Rating from '@sly/frontend/react/shared/components/Rating';
import dayjs from 'dayjs';
import { number, object, string } from 'prop-types';
import React from 'react';
import { Verified } from 'sly/icons';
import { getRelationText, getReviewerName } from 'sly/review/helpers';

function EntityReview({ value, createdAt, comments, info }: RatingType) {
  return (
    <div
      data-tp-id='gen-div-7d20eb48-4ea9-4567-8871-3b4bed181bbe'
      className='mr-m min-w-[75vw] rounded border-[1px] border-slate-400 p-m md:mr-0 md:min-w-fit md:border-0 md:p-0'
    >
      <div
        className='font-t-xs-azo mb-xxs text-slate-base'
        data-tp-id='gen-div-fe1da292-d0e5-42b9-8a2a-7d28759ad116'
      >
        {info && getReviewerName({ info })}
        <span
          className='font-b-m'
          data-tp-id='gen-span-e1c75d29-dbc9-405b-a3f5-2dabc1595fd4'
        >
          {' '}
          {info?.relation && getRelationText(info?.relation)}
        </span>
      </div>
      <div
        className='mb-m'
        data-tp-id='gen-div-e51f624f-be68-462a-bcaf-eddb81051101'
      >
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        <Rating width={4} value={value} color='primary' variation='base' />
      </div>
      <div
        className='mb-m'
        data-tp-id='gen-div-b74054d5-b7a4-4c7c-9bff-edaddd84f051'
      >
        {comments}
      </div>
      <div
        className='font-b-m reviewInfo flex items-center'
        data-tp-id='gen-div-7cde52f1-fa44-44b0-bd48-75394631cfc2'
      >
        <div
          className='text-slate-lighter-40'
          data-tp-id='gen-div-1290f763-ae12-4425-9748-ee9302bf42d1'
        >
          {dayjs(createdAt).format('MMMM YYYY')}
        </div>
        {info?.isVerified && (
          <div
            className='ml-s flex items-center'
            data-tp-id='gen-div-9b5c8d79-b66b-480b-aa7d-61d237bb1987'
          >
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/*@ts-ignore*/}
            <Verified size='s' color='text-green-base' />
            <span
              className='ml-xxs text-green-base'
              data-tp-id='gen-span-aaa3b3b8-153f-4a27-9569-2b4a3b0fba56'
            >
              Verified Review
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

EntityReview.propTypes = {
  value: number.isRequired,
  createdAt: string.isRequired,
  comments: string.isRequired,
  info: object,
};

EntityReview.defaultProps = {
  info: {},
};

export default EntityReview;
